import React from 'react';
import { LEGAL_DOCUMENTS } from './legalDocuments';
import styles from './LegalFooterLinks.module.css';

/**
 * LegalFooterLinks — "Privacy Notice · Terms of Service" footer links.
 *
 * Opens in a new tab by default: the app has no router, so navigating the
 * current tab to /privacy would drop whatever the user was in the middle of
 * (e.g. an unsaved listing form).
 *
 * @param {object} props
 * @param {'light'|'dark'} [props.variant='light'] - 'dark' for the sidebar surface.
 * @param {boolean} [props.newTab=true] - Open the documents in a new tab.
 * @param {string} [props.className] - Extra class for layout by the parent.
 */
const LegalFooterLinks = ({ variant = 'light', newTab = true, className = '' }) => {
  const linkProps = newTab ? { target: '_blank', rel: 'noopener noreferrer' } : {};
  const docs = [LEGAL_DOCUMENTS.privacy, LEGAL_DOCUMENTS.terms];

  return (
    <nav
      aria-label="Legal"
      className={`${styles.links} ${variant === 'dark' ? styles.dark : styles.light} ${className}`.trim()}
    >
      {docs.map((doc, index) => (
        <React.Fragment key={doc.key}>
          {index > 0 && <span className={styles.separator} aria-hidden="true">·</span>}
          <a href={doc.path} className={styles.link} {...linkProps}>
            {doc.title}
          </a>
        </React.Fragment>
      ))}
    </nav>
  );
};

export default LegalFooterLinks;
